/**
 * §11.10 Trust Center Final CTA — link to /contact?topic=security.
 */

import React from 'react'
import { ShieldCheck, MessageSquare, ScrollText, Sparkles } from 'lucide-react'
import {
  Container, Eyebrow, GradientButton, GhostButton,
} from '@/components/landing/design-system'

export default function FinalCTA() {
  return (
    <section className="relative py-24 md:py-32 overflow-hidden">
      <div className="pointer-events-none absolute inset-0 -z-10 opacity-[0.6]"
        style={{ background: 'radial-gradient(60% 45% at 50% 20%, rgba(34,197,94,0.14), transparent 70%), radial-gradient(60% 45% at 50% 20%, rgba(255,193,7,0.12), transparent 70%)' }} />
      <div className="pointer-events-none absolute inset-x-0 top-0 -z-10 h-px bg-gradient-to-r from-transparent via-white/15 to-transparent" />
      <Container size="wide">
        <div className="relative rounded-3xl border border-white/10 bg-gradient-to-b from-white/[0.04] to-white/[0.01] p-8 md:p-12 lg:p-14 backdrop-blur-xl overflow-hidden">
          <div className="pointer-events-none absolute -top-20 -left-20 h-64 w-64 rounded-full bg-emerald-500/10 blur-3xl" />
          <div className="pointer-events-none absolute -bottom-20 -right-20 h-64 w-64 rounded-full bg-brand-gold/10 blur-3xl" />
          <div className="relative flex flex-col items-center text-center gap-6 max-w-3xl mx-auto">
            <Eyebrow tone="green">Talk to us</Eyebrow>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-semibold tracking-tight text-white leading-[1.05]">
              Have security or compliance{' '}
              <span className="bg-gradient-to-r from-brand-gold to-[#FFE17A] bg-clip-text text-transparent">questions?</span>
            </h2>
            <p className="text-base md:text-lg text-zinc-400 leading-relaxed">
              Our security team is happy to walk you through the platform posture,
              share the enterprise procurement pack under NDA, and support your
              vendor-risk review from evaluation through renewal.
            </p>
            <div className="flex flex-col sm:flex-row items-stretch gap-3 pt-2">
              <GradientButton href="/contact?topic=security" size="lg">
                <ShieldCheck className="h-4 w-4" /> Contact security team
              </GradientButton>
              <GhostButton href="/contact?topic=procurement" size="lg" trailingIcon>
                <ScrollText className="h-4 w-4" /> Request procurement pack
              </GhostButton>
              <GhostButton href="/contact" size="lg" trailingIcon>
                <MessageSquare className="h-4 w-4" /> General enquiries
              </GhostButton>
            </div>
            <div className="mt-4 flex flex-wrap items-center justify-center gap-2 text-[11px] text-zinc-500">
              <span className="inline-flex items-center gap-1.5"><Sparkles className="h-3 w-3 text-emerald-400" /> security@kalkiai.trade</span>
              <span>·</span><span>NDA available</span>
              <span>·</span><span>Business-hours response</span>
              <span>·</span><span>Enterprise 24×7</span>
            </div>
          </div>
        </div>
      </Container>
    </section>
  )
}
